import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\Picture\CopyPictureIntoAttachmentsController::__invoke
* @see app/Http/Controllers/Dossier/Picture/CopyPictureIntoAttachmentsController.php
* @route '/api/dossier/{dossier}/gallery/copy-attachment/{picture}'
*/
const CopyPictureIntoAttachmentsController = (args: { dossier: string | number | { id: string | number }, picture: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, picture: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CopyPictureIntoAttachmentsController.url(args, options),
    method: 'post',
})

CopyPictureIntoAttachmentsController.definition = {
    methods: ["post"],
    url: '/api/dossier/{dossier}/gallery/copy-attachment/{picture}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Dossier\Picture\CopyPictureIntoAttachmentsController::__invoke
* @see app/Http/Controllers/Dossier/Picture/CopyPictureIntoAttachmentsController.php
* @route '/api/dossier/{dossier}/gallery/copy-attachment/{picture}'
*/
CopyPictureIntoAttachmentsController.url = (args: { dossier: string | number | { id: string | number }, picture: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, picture: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
            picture: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
        picture: typeof args.picture === 'object'
        ? args.picture.id
        : args.picture,
    }

    return CopyPictureIntoAttachmentsController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace('{picture}', parsedArgs.picture.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\Picture\CopyPictureIntoAttachmentsController::__invoke
* @see app/Http/Controllers/Dossier/Picture/CopyPictureIntoAttachmentsController.php
* @route '/api/dossier/{dossier}/gallery/copy-attachment/{picture}'
*/
CopyPictureIntoAttachmentsController.post = (args: { dossier: string | number | { id: string | number }, picture: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, picture: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CopyPictureIntoAttachmentsController.url(args, options),
    method: 'post',
})

export default CopyPictureIntoAttachmentsController